
import moment from 'moment';
import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { getMainStayList } from '@/api/stay';
import { addFavoriteItem, deleteFavoriteItem } from '@/api/favoriteItem';
import { UserModule } from '@/store/user';
import { getMainStoreInfoList, getMainThemeRecommendList } from '@/api/storeInfo';
import { getMainEventPostList } from '@/api/eventPost';
import { getBannerList } from '@/api/banner';
import { getIndustryList } from '@/api/industry';
import { getOptionItemList } from '@/api/optionItem';
import { getPostList } from '@/api/post';
import { getPopupList } from '@/api/popup';
// import { getMainPageData } from '@/api/mainPage';
// import { faAnglesDown } from '@fortawesome/free-solid-svg-icons';
import Calendar from '@/components/Calendar/index.vue';
import $ from 'jquery';
import Slick from 'vue-slick';

import {
  getLat,
  getLng,
  setLat,
  setLng,
} from '@/utils/cookies';
import { getCurrentPosition } from '@/utils/mylocation';
import { getRecentList } from '@/utils/localStorage';
import AiSearchList from './components/aiSearchList.vue';

@Component({
  components: {
    Calendar,
    AiSearchList,
    Slick,
  },
})

export default class extends Vue {
  mounted() {
    this.init();
    this.slotVisibleDefault = true;
    this.slotVisibleAi = false;
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('scroll', this.handleSearch);
    window.addEventListener('scroll', this.handleFix);

    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    if (/android/i.test(userAgent)) {
      this.appLink = 'https://play.google.com/store/apps/details?id=com.tourplatform.namhae&hl=ko';
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      this.appLink = 'https://apps.apple.com/kr/app/%EB%82%AD%EB%A7%8C%EB%82%A8%ED%95%B4/id6477441950';
    } else {
      this.appLink = 'https://play.google.com/store/apps/details?id=com.tourplatform.namhae&hl=ko';
    }
    this.openPopups();
    setTimeout(() => {
      this.loadingClass = true;
    }, 2500);
    // 최근 목록
    this.recentList = getRecentList();
  }

  private getCookie(name: string) {
    const value = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
    return value ? value[2] : null;
  }

  private setCookie(name: string, value: string, days: number) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
  }

  private openPopups() {
    if (window.innerWidth <= 700) return;
    getPopupList().then((res: any) => {
      const popups = res.data;
      if (!popups || !popups.length) return;
      popups.forEach((popup: any, index: number) => {
        const cookieKey = `popup_${popup.uid}`;
        if (this.getCookie(cookieKey) === 'true') return;
        const left = popup.marginLeft || (200 + index * 50);
        const top = popup.marginTop || (100 + index * 50);
        const option = `width=${popup.width},height=${popup.height},top=${top},left=${left},location=no`;
        const openWindow = window.open('', '_blank', option);
        if (!openWindow) return;
        const imgUrl = `${this.apiUrl}/attached-file/${popup.fileUid}`;
        /* eslint-disable quotes */
        const html = `<!DOCTYPE html><html><head><style>body{margin:0}</style></head><body>`
          + `<img src="${imgUrl}" style="width:100%;height:calc(100% - 30px);object-fit:contain;cursor:pointer" onclick="window.close();">`
          + `<div style="text-align:right;padding:4px 10px;font-size:13px;font-family:sans-serif;">`
          + `<label><input type="checkbox" id="chk" onclick="document.cookie='${cookieKey}=true;path=/;max-age=86400';window.close();"> `
          + `오늘 하루 보지않기</label></div></body></html>`;
        /* eslint-enable quotes */
        openWindow.document.write(html);
        openWindow.document.close();
      });
    });
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('scroll', this.handleSearch);
    window.removeEventListener('scroll', this.handleFix);
  }

  get currentColor(): string {
    const date = new Date();
    const hour = date.getHours();

    if (hour >= 7 && hour < 18) {
      return 'color07';
    }
    if (hour >= 18 && hour < 20) {
      return 'color18';
    }
    if (hour >= 20 && hour < 24) {
      return 'color20';
    }
    if (hour >= 0 && hour < 4) {
      return 'color20';
    }
    if (hour >= 4 && hour < 7) {
      return 'color4';
    }
    return '';
  }

  private appLink = '#';

  private postList = [];

  private activeMenu = false;

  private apiUrl = process.env.VUE_APP_COMMON_API;

  private totalSearchQuery: any = {
    searchValue: '',
    industryIdx: [],
    startDate: '',
    endDate: '',
    adult: 0,
    child: 0,
  }

  private loadingClass = false;

  private mainLoading = true;

  private dialogTitle = '';

  private favoriteStatus = '';

  private loading = true;

  private searchInput = '';

  private recentList: any = [];

  private isMarked= false;

  private isScrolled= false;

  private isSearch= false;

  private isFixed= false;

  private centerDialogVisible= false;

  private dialogNotifyVisible = false;

  private isClickActive = false;

  private slotVisible= false;

  private regionList = [];

  private stayList = [];

  private certMarkstayList = [];

  private eventList = [];

  private bannerList = [];

  private pageSize = (window as any).innerWidth;

  private searchClose1 = true;

  private searchClose2 = true;

  private mainItem = {
    stayList: [],
    restaurantList: [],
    placeList: [],
    excitingList: [],
  }

  private mainThemeItem = [];

  private mainBannerOptions = {
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 400,
    dots: false,
    centerMode: true,
    prevArrow: $('.main__slide-prev'),
    nextArrow: $('.main__slide-next'),
    dotsClass: 'slick-dots banner__slide-dots',
    draggable: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 2560,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          centerMode: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
    ],
  };

  private bannerCurrentSlide = 0;

  private BannerlChange(event: any, slick: any, currentSlide: number): void {
    this.bannerCurrentSlide = currentSlide;
  }

  get formattedbannerCurrentSlide(): string {
    return String(this.bannerCurrentSlide + 1).padStart(2, '0');
  }

  get formattedbannerTotalSlides(): string {
    return String(this.eventList.length).padStart(2, '0');
  }

  get progressbannerPercentage(): number {
    if (!this.eventList.length) return 0;
    return ((this.bannerCurrentSlide + 1) / this.eventList.length) * 100;
  }

  private eventOptions = {
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 400,
    dots: true,
    dotsClass: 'slick-dots event__slide-dots',
    draggable: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  private shortsOptions = {
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    speed: 400,
    dots: false,
    draggable: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  private listQuery: any = {
    page: 0,
    size: 8,
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().add(1, 'days').format('YYYY-MM-DD'),
    lat: '37.566826',
    lng: '126.9786567',
    sort: 'distance',
    region: '',
    adult: 2,
    child: 0,
    startPrice: 0,
    endPrice: 1000000,
    categories: '',
    options: '',
  }

  private shortListQuery: any = {
    boardUid: process.env.VUE_APP_SHORT_BOARD_UID,
    page: 0,
    size: 10,
    searchType: '',
    searchValue: '',
  }

  private industryList = [];

  private dateRange = [
    moment().format('YYYY-MM-DD'),
    moment().add(1, 'days').format('YYYY-MM-DD'),
  ];

  private focusInput() {
    this.dialog = true;
    this.$nextTick(() => {
      const inputElement = (this.$refs.searchInput as any).$el.querySelector('input');
      inputElement.focus();
      document.documentElement.classList.add('noscr');
    });
  }

  private async init() {
    try {
      const position = await getCurrentPosition();
      this.listQuery.lat = position.lat;
      this.listQuery.lng = position.lng;
      this.totalSearchQuery.lat = position.lat;
      this.totalSearchQuery.lng = position.lng;
    } catch (error) {
      this.$message.error('위치 정보를 가져오는 데 실패했습니다.');
    }
    this.getBannerList();
    this.getIndustryList();
    this.getMainEventList();
    this.getMainThemeList();
    this.getPostList();
    this.getRegionList();
    this.getMainStayList();
    this.getMainStoreInfoList();
  }

  private goRecent(link: string) {
    this.$router.push(link);
  }

  private handleResize() {
    this.pageSize = (window as any).innerWidth;
  }

  private selectedPersonnel() {
    this.slotVisible = !this.slotVisible;
  }

  private getMainStayList() {
    getMainStayList(this.listQuery).then((res) => {
      this.stayList = res.data;
      this.mainLoading = false;
    });
    this.listQuery.certMarkStatus = 1;
    getMainStayList(this.listQuery).then((res) => {
      this.certMarkstayList = res.data;
      this.mainLoading = false;
    });
    this.listQuery.certMarkStatus = null;
  }

  private handleViewStay(idx: any) {
    this.$router.push({
      name: 'StayDetail',
      params: { stayIdx: idx },
      query: {
        startDate: this.listQuery.startDate,
        endDate: this.listQuery.endDate,
        adult: this.listQuery.adult,
        child: this.listQuery.child,
      },
    });
  }

  private handleTotalSearch() {
    this.$router.push({ name: 'TotalSearch', query: { ...this.totalSearchQuery } });
    document.documentElement.classList.remove('noscr');
  }

  private favoriteFlag = false;

  private async handleAddFavoriteStay(event: Event, idx: any, type: number) {
    if (this.favoriteFlag) {
      this.$message.info('저장중입니다.');
      return;
    }
    this.favoriteFlag = true;
    if (UserModule.token) {
      const target = (event.target as HTMLElement)?.parentElement?.parentElement?.parentElement?.parentElement;
      if (target?.classList.contains('active')) {
        if (target.getAttribute('data-id')) {
          await deleteFavoriteItem(target.getAttribute('data-id')).then(() => {
            this.$message.success('삭제되었습니다.');
            target.classList.remove('active');
            target.removeAttribute('data-id');
          });
        } else {
          this.$message.info('해당 서비스를 찾을 수 없습니다.');
        }
      } else if (target && !(target?.classList.contains('active'))) {
        let query = {};
        if (type === 1) query = { stayIdx: idx };
        else if (type === 2) query = { storeInfoIdx: idx };
        await addFavoriteItem(query).then((res) => {
          this.$message.success('저장되었습니다.');
          target.classList.add('active');
          target.setAttribute('data-id', res.data);
        });
      }
    } else {
      this.$message.info('로그인이 필요한 서비스입니다.');
    }
    this.favoriteFlag = false;
  }

  private getMainStoreInfoList() {
    getMainStoreInfoList({
      page: 0,
      size: 6,
      lat: this.listQuery.lat,
      lng: this.listQuery.lng,
    }).then((res) => {
      this.mainItem = {
        ...this.mainItem,
        ...res.data,
      };
    });
  }

  private themeLoading = true;

  private async getMainThemeList() {
    await getMainThemeRecommendList().then((res) => {
      this.mainThemeItem = res.data;
      this.themeLoading = false;
    }).catch(() => { /* ignore */ });
  }

  private getMainEventList() {
    getMainEventPostList().then((res) => {
      this.eventList = res.data;
    });
  }

  private getBannerList() {
    getBannerList().then((res) => {
      this.bannerList = res.data;
      // 최상단으로 이동
      window.scrollTo(0, 0);
    });
  }

  private getPickerOptions() {
    const options = {
      disabledDate(time: any) {
        return moment(time).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD');
      },
    };
    return options;
  }

  private getIndustryList() {
    getIndustryList().then((res) => {
      this.industryList = res.data;
      this.industryList = this.industryList.filter((item: any) => {
        if (item.name === '일반상품' || item.name === '테스트') return false;
        if (item.idx === 3) return false;
        if (item.idx === 2) {
          item.name = '레저 / 체험';
        }
        return true;
      });
    });
  }

  private getRegionList() {
    getOptionItemList('REGION').then((res) => {
      this.regionList = res.data;
    });
  }

  private getPostList() {
    this.loading = true;
    getPostList(this.shortListQuery).then((res) => {
      this.postList = res.data.content;
      this.loading = false;
    });
  }

  private slotVisibleDefault = true;

  private slotVisibleAi= false;

  private isSeclect01Visible = false;

  private isSeclect02Visible = false;

  private isSeclect03Visible = false;

  private isSeclect04Visible = false;

  private openSeclect01() {
    this.isSeclect01Visible = !this.isSeclect01Visible;
    this.isSeclect02Visible = false;
    this.isSeclect03Visible = false;
    this.isSeclect04Visible = false;
  }

  private openSeclect02() {
    this.isSeclect01Visible = false;
    this.isSeclect03Visible = false;
    this.isSeclect04Visible = false;
    this.isSeclect02Visible = !this.isSeclect02Visible;
  }

  private openSeclect03() {
    this.isSeclect01Visible = false;
    this.isSeclect02Visible = false;
    this.isSeclect04Visible = false;
    this.isSeclect03Visible = !this.isSeclect03Visible;
  }

  private openSeclect04() {
    this.isSeclect01Visible = false;
    this.isSeclect02Visible = false;
    this.isSeclect03Visible = false;
    this.isSeclect04Visible = !this.isSeclect04Visible;
  }

  private closeModal() {
    this.isSeclect01Visible = false;
    this.isSeclect02Visible = false;
    this.isSeclect03Visible = false;
    this.isSeclect04Visible = false;
  }

  private handleScroll() {
    if (window.scrollY > 300) {
      this.isScrolled = true;
    } else {
      this.isScrolled = false;
    }
  }

  private handleSearch() {
    const windowHeight = window.innerHeight;
    const scrollPosition = window.scrollY;
    const scrollPercent = (scrollPosition / windowHeight) * 100;

    // 여기에서 적절한 퍼센트 값을 설정합니다.
    if (scrollPercent > 36) { // 예시: 스크롤 위치가 화면의 절반 이상인 경우
      this.isSearch = true;
    } else {
      this.isSearch = false;
    }
  }

  private handleFix() {
    if (window.scrollY > 4200) {
      this.isSearch = false;
      this.isScrolled = false;
      this.isFixed = true;
    } else {
      this.isFixed = false;
    }
  }

  private truncateText(text: string, maxLength: number): string {
    if (text.length > maxLength) {
      return `${text.slice(0, maxLength)}...`;
    }
    return text;
  }

  private truncateName(name: string, maxLength: number) :string {
    if (name.length > maxLength) {
      return `${name.slice(0, maxLength)}...`;
    }
    return name;
  }

  private handleSearchDialogVisible() {
    this.dialogTitle = '통합검색';
    this.centerDialogVisible = !this.centerDialogVisible;
    this.slotVisibleAi = false;
    if (!this.slotVisibleDefault) this.slotVisibleDefault = true;
    // 모달 닫을 때 <html> 스크롤 되도록
    document.documentElement.classList.remove('noscr');
  }

  private handleDefaultSearch() {
    this.slotVisibleDefault = true;
    this.slotVisibleAi = false;
    this.isClickActive = false;
  }

  private handleAisearch() {
    this.dialogTitle = '낭만\'s PICK';
    if (!this.centerDialogVisible) this.centerDialogVisible = true;
    this.slotVisibleDefault = false;
    this.slotVisibleAi = true;
    this.isClickActive = !this.isClickActive;
  }

  private calendarData = []; // 달력 일별 데이터

  private selectedDay: string | null = '';

  private selectedMonth = moment().format('YYYY-MM');

  private handleChangeMonth(yearMonth: any) {
    this.selectedMonth = moment(yearMonth).format('YYYY-MM');
    this.calendarData = [];
  }

  private handleChoiceDate(startDate: string, endDate: string) {
    this.selectedDay = startDate;
    this.totalSearchQuery.startDate = startDate;
    this.totalSearchQuery.endDate = endDate;
  }

  private handleKeyup(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.handleTotalSearch();
    }
  }

  private distanceType(distance: number | string): number {
    const value = Number(distance);
    if (value > 1000) {
      return value / 1000;
    }
    return 0;
  }

  private handleResetFormQuery() {
    this.totalSearchQuery = {
      searchValue: '',
      industryIdx: [],
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().add(1, 'days').format('YYYY-MM-DD'),
      adult: 0,
      child: 0,
      page: 0,
      size: 4,
    };
    const calendarRef: any = this.$refs.calendar;
    if (calendarRef) calendarRef.removeActiveClass();
  }

  private stayNavigateToDetail(stayIdx: string) {
    this.$router.push({ name: 'StayDetail', params: { stayIdx } });
  }

  private shortsNavigateToDetail(short: any) {
    const inputValue = short.dataList?.[0]?.inputValue;

    if (inputValue) {
      window.open(inputValue, '_blank');
    }
  }

  private restaurantNavigateToDetail(storeIdx: string) {
    this.$router.push({ name: 'RestaurantView', params: { idx: storeIdx } });
  }

  // private hotplaceNavigateToDetail(storeIdx: string) {
  //   this.$router.push({ name: 'PlaceView', params: { idx: storeIdx } });
  // }

  private leisureNavigateToDetail(storeIdx: string) {
    this.$router.push({ name: 'LeisureView', params: { idx: storeIdx } });
  }

  private experiencNavigateToDetail(storeIdx: string) {
    this.$router.push({ name: 'ExcitingView', params: { idx: storeIdx } });
  }

  private accomodationOptions = {
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: $('.accomodation__prev'),
    nextArrow: $('.accomodation__next'),
    speed: 400,
    dots: false,
    draggable: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          rows: 2,
          autoplay: false,
        },
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 1,
          rows: 2,
          autoplay: false,
        },
      },
    ],
  };

  private themeCurrentSlide = 0;

  private themeOptions = {
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 400,
    dots: false,
    draggable: true,
    pauseOnHover: true,
  };

  private ThemelChange(event: any, slick: any, themeCurrentSlide: number): void {
    this.themeCurrentSlide = themeCurrentSlide;
  }

  get formattedThemeCurrentSlide(): string {
    return String(this.themeCurrentSlide + 1).padStart(2, '0');
  }

  get formattedThemeTotalSlides(): string {
    return String(this.mainThemeItem.length).padStart(2, '0');
  }

  get progressThemePercentage(): number {
    if (!this.mainThemeItem.length) return 0;
    return ((this.themeCurrentSlide + 1) / this.mainThemeItem.length) * 100;
  }

  private handleClickBannerSlide1(str: string) {
    const slick = (this.$refs.eventBannerPC as any);
    if (str === 'next') {
      slick.next();
    } else {
      slick.prev();
    }
  }

  private handleClickBannerSlide2(str: string) {
    const slick = (this.$refs.eventBannerMobile as any);
    if (str === 'next') {
      slick.next();
    } else {
      slick.prev();
    }
  }

  private handleClickThemeSlide(str: string) {
    const slick = (this.$refs.themeBanner as any);
  }

  private handleClickRecommendationSlide(str: string) {
    const slick = (this.$refs.recommendationBanner as any);
    if (str === 'next') {
      slick.next();
    } else {
      slick.prev();
    }
  }

  private handleClickAccomodationSlide(str: string) {
    const slick = (this.$refs.accomodationBanner as any);
    if (str === 'next') {
      slick.next();
    } else {
      slick.prev();
    }
  }

  private handleClickShortsSlide(str: string) {
    const slick = (this.$refs.shortsBanner as any);
    if (str === 'next') {
      slick.next();
    } else {
      slick.prev();
    }
  }

  private restaurantOptions = {
    autoplay: true,
    autoplaySpeed: 4000,
    // arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: $('.restaurant__prev'),
    nextArrow: $('.restaurant__next'),
    speed: 400,
    dots: false,
    draggable: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          rows: 1,
          autoplay: false,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          rows: 1,
          autoplaySpeed: 10000,
          speed: 600,
          autoplay: true,
        },
      },
    ],
  };

  private handleClickRestaurantSlide(str: string) {
    const slick = (this.$refs.restaurantBanner as any);
    if (str === 'next') {
      slick.next();
    } else {
      slick.prev();
    }
  }

  private hotplaceOptions = {
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: $('.hotplace__prev'),
    nextArrow: $('.hotplace__next'),
    speed: 400,
    dots: false,
    draggable: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          rows: 1,
          autoplay: true,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          rows: 1,
          autoplaySpeed: 10000,
          speed: 600,
          autoplay: true,
        },
      },
    ],
  };

  private handleClickHotplaceSlide(str: string) {
    const slick = (this.$refs.hotplaceBanner as any);
    if (str === 'next') {
      slick.next();
    } else {
      slick.prev();
    }
  }

  private leisureOptions = {
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: $('.leisure__prev'),
    nextArrow: $('.leisure__next'),
    speed: 400,
    dots: false,
    draggable: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          rows: 1,
          autoplay: true,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          rows: 1,
          autoplaySpeed: 10000,
          speed: 600,
          autoplay: true,
        },
      },
    ],
  };

  private handleClickLeisureSlide(str: string) {
    const slick = (this.$refs.leisureBanner as any);
    if (str === 'next') {
      slick.next();
    } else {
      slick.prev();
    }
  }

  private experimentOptions = {
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: $('.experiment__prev'),
    nextArrow: $('.experiment__next'),
    speed: 400,
    dots: false,
    draggable: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          rows: 1,
          autoplay: true,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          rows: 1,
          autoplaySpeed: 10000,
          speed: 600,
          autoplay: true,
        },
      },
    ],
  };

  private handleClickExperimentSlide(str: string) {
    const slick = (this.$refs.experimentBanner as any);
    if (str === 'next') {
      slick.next();
    } else {
      slick.prev();
    }
  }

  private dialog = false;

  private closeAiDialog() {
    this.dialog = true;
  }

  private handleCloseDialog(isClose: boolean) {
    // 추가적인 로직 구현
  }

  private handleScrollToTop(event: Event): void {
    event.preventDefault(); // 기본 동작 방지
    window.scrollTo({ top: 0, behavior: 'smooth' }); // 부드러운 스크롤 적용
  }
}
